import { createContext, useContext } from "react";
import { Commodity } from "./products";


export const ProductContext = createContext<Commodity | undefined>(undefined);

export function useProduct() {
  return useContext(ProductContext);
}